import { useEffect, useState } from "react";
import { Search, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Pick = ({ label, value, items, onChange, disabled, loading, testid }) => (
  <div>
    <Label className="text-xs">{label}</Label>
    <Select value={value ? String(value) : undefined} onValueChange={(v) => onChange(Number(v))} disabled={disabled || loading}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder={loading ? "Yükleniyor…" : `${label} seçin`} /></SelectTrigger>
      <SelectContent className="max-h-72">
        {items.map((x) => <SelectItem key={x.id} value={String(x.id)} data-testid={`${testid}-opt-${x.id}`}>{x.name}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

const useList = (url, onError) => {
  const [state, setState] = useState({ items: [], loading: false });
  useEffect(() => {
    if (!url) return setState({ items: [], loading: false });
    setState({ items: [], loading: true });
    api.get(url).then(({ data }) => setState({ items: data, loading: false }))
      .catch((x) => { setState({ items: [], loading: false }); onError(x); });
  }, [url]);
  return state;
};

export function ParcelSearchForm({ onSearch, busy, onError }) {
  const [il, setIl] = useState(null);
  const [ilce, setIlce] = useState(null);
  const [mah, setMah] = useState(null);
  const [ada, setAda] = useState("");
  const [parsel, setParsel] = useState("");
  const ils = useList("/parcels/provinces", onError);
  const ilces = useList(il && `/parcels/districts/${il}`, onError);
  const mahs = useList(ilce && `/parcels/neighborhoods/${ilce}`, onError);

  const submit = (e) => { e.preventDefault(); onSearch({ mahalle_id: mah, ada: ada.trim(), parsel: parsel.trim() }); };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="parcel-search-form">
      <Pick label="İl" testid="parcel-il-select" value={il} items={ils.items} loading={ils.loading} onChange={(v) => { setIl(v); setIlce(null); setMah(null); }} />
      <Pick label="İlçe" testid="parcel-ilce-select" value={ilce} items={ilces.items} loading={ilces.loading} disabled={!il} onChange={(v) => { setIlce(v); setMah(null); }} />
      <Pick label="Mahalle / Köy" testid="parcel-mahalle-select" value={mah} items={mahs.items} loading={mahs.loading} disabled={!ilce} onChange={setMah} />
      <div className="grid grid-cols-2 gap-3">
        <div><Label className="text-xs">Ada</Label><Input data-testid="parcel-ada-input" inputMode="numeric" pattern="\d{1,10}" required value={ada} onChange={(e) => setAda(e.target.value.replace(/\D/g, ""))} placeholder="örn. 130188" /></div>
        <div><Label className="text-xs">Parsel</Label><Input data-testid="parcel-parsel-input" inputMode="numeric" pattern="\d{1,10}" required value={parsel} onChange={(e) => setParsel(e.target.value.replace(/\D/g, ""))} placeholder="örn. 7" /></div>
      </div>
      <div className="text-[11px] text-slate-400">Adası olmayan (köy/kırsal) parsellerde ada için 0 yazın.</div>
      <Button type="submit" data-testid="parcel-search-submit" disabled={!mah || busy} className="w-full bg-emerald-700 hover:bg-emerald-800">
        {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Search className="w-4 h-4 mr-2" />}Sorgula
      </Button>
    </form>
  );
}
